module.exports = __webpack_public_path__ + "static/daddyfootballvest-8dcccacc4ef8e1597aaaf86785ec7c3f.jpeg";